import axios from 'axios';
import get from 'lodash.get';

export const customerSummaryUrl = '/customer/orderSummary';

export const getCustomerSummaryForCustomerId = async (customerId) => {
  if (!customerId) {
    throw new Error('No valid CustomerID provided');
  }
  return axios.post(customerSummaryUrl, { customerIds: [customerId] }).then((response) => {
    const result = get(response, 'data.customerOrderSummaries') || [];
    if (result.length > 0) {
      return result[0];
    }
    throw new Error(`Error retrieving summary data for CustomerID: ${customerId}`);
  });
};
